/* globals jQuery */

const $ = jQuery;
const { dateI18n = () => {} } = ( window.wp || {} ).date || {};

function parseTweet( tweet ) {
	/* eslint-disable camelcase */

	let { text } = tweet;
	const {
		retweeted_status = false,
		entities: {
			urls = [],
			media = [],
			user_mentions = [],
			hashtags = [],
		},
	} = tweet;

	if ( retweeted_status ) {
		text = text.replace( /^RT @(\w+):/, `RT <a href="https://twitter.com/$1" title="Retweeted from ${ tweet.retweeted_status.user.name }" target="_blank" rel="nofollow">@$1</a>` );
	}

	// Convert URLs to links
	for ( const entity of urls ) {
		const { url, display_url } = entity;
		text = text.replace( url, `<a href="${ url }" target="_blank" rel="noopener nofollow">${ display_url }</a>` );
	}

	// Hide Media for now
	for ( const entity of media ) {
		const { url } = entity;
		text = text.replace( url, '' );
	}

	// Convert mentions to links
	for ( const entity of user_mentions ) {
		const { screen_name, name: display_name } = entity;
		text = text.replace( `@${ screen_name }`, `<a href="https://twitter.com/${ screen_name }" title="${ display_name }" target="_blank" rel="nofollow">@${ screen_name }</a>` );
	}

	// Convert hashtags to links
	for ( const entity of hashtags ) {
		const { text: tag } = entity;
		text = text.replace( `#${ tag }`, `<a href="https://twitter.com/search?q=${ encodeURIComponent( '#' + tag ) }" title="${ tag }" target="_blank" rel="nofollow">#${ tag }</a>` );
	}

	return text;

	/* eslint-enable camelcase */
}

export default function( tweets, template ) {
	return tweets.map( tweet => {
		const authorUrl = `https://twitter.com/${ tweet.user.screen_name }`;
		const tweetUrl = `${ authorUrl }/status/${ tweet.id_str }`;
		const created = new Date( tweet.created_at );
		const content = parseTweet( tweet );

		const $tweet = $( template );

		const linkAttrs = {
			target: '_blank',
			rel: 'noopener nofollow',
		};

		$tweet.find( '.js-tweet-author-name' )
			.text( tweet.user.name );

		$tweet.find( '.js-tweet-author-handle' )
			.text( `@${ tweet.user.screen_name }` );

		$tweet.find( '.js-tweet-author-link' )
			.attr( {
				...linkAttrs,
				href: authorUrl,
			} );

		$tweet.find( '.js-tweet-link' )
			.attr( {
				...linkAttrs,
				href: tweetUrl,
			} );

		$tweet.find( '.js-tweet-date' )
			.attr( 'title', created )
			.text( dateI18n( 'd.m.Y', created ) );

		$tweet.find( '.js-tweet-text' )
			.html( content );

		return $tweet;
	} );
}
